import * as React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { inject, observer } from 'mobx-react'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import { NavigationMenuStore } from '../../store/navigation-menu/navigation-menu-store'
import { AppStore } from '../../store/app/app-store'
import { APP_STORE, NAVIGATION_MENU_STORE } from '../../store/stores'
import LOGO from '../../assets/img/logo_small.png'
import { lg } from '../../utils/css/breakpoints'
import { NavBar } from '../nav-bar/nav-bar'
import { goTo } from '../../utils/router-utils'
import { ROOT } from '../../routes/app-routes'
import styles from './navigation-menu.scss'

@inject(APP_STORE)
@inject(NAVIGATION_MENU_STORE)
@observer
export class NavigationMenu extends React.Component {

    static propTypes = {
        appStore: PropTypes.instanceOf(AppStore),
        navigationMenuStore: PropTypes.instanceOf(NavigationMenuStore)
    }

    selectItemHandler = item => {
        const { navigationMenuStore } = this.props
        const { screenWidth } = this.props.appStore

        navigationMenuStore.selectMenuItem(item)

        if (screenWidth < lg) {
            navigationMenuStore.open = false
        }
    }

    render() {
        const { navBarItems, selectedItem, open, setOpen } = this.props.navigationMenuStore
        const { screenWidth } = this.props.appStore

        return (
            <Drawer
                id="navigationMenu"
                className={classNames({
                    [styles.hidden]: !open && screenWidth >= lg
                })}
                PaperProps={{
                    className: styles.navigationMenu
                }}
                variant={screenWidth < lg ? 'temporary' : 'permanent'}
                open={open}
                onClose={() => setOpen(!open)}
            >
                <div className={styles.logoContainer}>
                    <button
                        type="button"
                        onClick={() => goTo(ROOT)}
                    >
                        <img
                            id="logo"
                            className={styles.logo}
                            alt="SetMarks"
                            src={LOGO}
                        />
                    </button>
                </div>
                <Divider/>
                <NavBar
                    id="navigationMenuNavBar"
                    selectedItem={selectedItem}
                    className={styles.navBar}
                    items={navBarItems.slice()}
                    onItemSelect={this.selectItemHandler}
                />
            </Drawer>
        )
    }
}
